(function () {
  const COUNTRY = 'JP';
  const PROVINCE = 'Tokyo';
  const ZIP = '1000001'; // default zip for rate lookup

  function formatMoney(cents) {
    return Math.round(cents / 100).toLocaleString('ja-JP') + '円';
  }

  function updateShippingDisplay(text, isFree) {
    const el = document.getElementById('cart-shipping-value');
    if (!el) return;
    if (isFree) {
      el.textContent = text;
      el.classList.add('cart-summary__shipping-free');
    } else {
      el.textContent = text;
      el.classList.remove('cart-summary__shipping-free');
    }
  }

  function fetchShippingRates() {
    const el = document.getElementById('cart-shipping-value');
    if (!el) return;

    const params = new URLSearchParams({
      'shipping_address[zip]': ZIP,
      'shipping_address[country]': COUNTRY,
      'shipping_address[province]': PROVINCE,
    });

    fetch(`/cart/shipping_rates.json?${params}`)
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(function (data) {
        const rates = data.shipping_rates;
        if (!rates || rates.length === 0) {
          updateShippingDisplay(el.dataset.fallback, false);
          return;
        }
        // Use the lowest rate
        var lowest = rates.reduce(function (min, r) {
          var price = parseFloat(r.price);
          return price < min ? price : min;
        }, parseFloat(rates[0].price));

        var cents = Math.round(lowest * 100);
        if (cents === 0) {
          updateShippingDisplay('無料', true);
        } else {
          updateShippingDisplay(formatMoney(cents), false);
        }
      })
      .catch(function () {
        updateShippingDisplay(el.dataset.fallback, false);
      });
  }

  // Fetch on page load
  fetchShippingRates();

  // Re-fetch after cart updates
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      // Small delay to let section re-render complete
      setTimeout(fetchShippingRates, 300);
    });
  }
})();
